// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import DateRange from '../core/date-range';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'providers';

class Providers extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'name',
                link: '/providers',
                linkKey: 'partnerId',
                title: 'Name',
                type: 'link',
                width: '56%',
            },
            {
                dataKey: 'partnerId',
                title: 'Partner ID',
                width: '20%',
            },
            {
                dataKey: 'dateCreated',
                title: 'Date Created',
                type: 'date',
                width: '12%',
            },
            {
                dataKey: 'lastUpdated',
                title: 'Last Update',
                type: 'date',
                width: '12%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            blacklistKeys: ['providerId', 'version'],
            keyOrder: 'providers',
            whitelistKeys: [
                'name',
                'partnerId',
                'playerType',
                'guid',
                'dateCreated',
                'createdBy',
                'lastUpdated',
                'lastModifiedBy',
            ],
        };
    }

    getTablewithsortProps() {
        return {
            activeRowValueKey: 'routerParams.partnerId',
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            updateOnUrlChange: false,
            ...this.props,
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Name" name="name" title="Use wildcard (*) for partial name match" />
            <Input label="Partner ID" name="partnerId" />
            <DateRange label="Created" name="dateCreated" />
            <DateRange label="Last Updated" name="lastUpdated" />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;

        return (
            <Permissions
                accessRequirement="read"
                elementService="provider"
                notAuthorizedMessage={true}
                requiresServiceAccess={true}
            >
                <div className="providers">
                    <ServicesExportPanelAction searchData={searchData} />
                    <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                    <SearchPagination {...this.getPaginationProps()} />
                    <SearchTableWithSort {...this.getTablewithsortProps()} />
                </div>
            </Permissions>
        );
    }
}

Providers.propTypes = {
    query: PropTypes.object,
    rowDetails: PropTypes.array,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Providers, servicesDataKey);
